<script lang="ts">
	import type { PageData } from './$types';
	import Footer from '$lib/components/footer/Footer.svelte';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import DatasheetPanel from '$lib/components/pois/datasheet/DatasheetPanel.svelte';
	import { isDatasheetPoiData } from '$lib/components/pois/utils';
	import { ROUTE_ON_THE_WAY } from '$lib/constants/route';
	import { getSearchParamsStore, gotoWithParams } from '$lib/services/urls/searchParams';
	import { onMount } from 'svelte';

	export let data: PageData;
	$: ({ poisStore, partnersLinks } = data);
	$: ({ selectedPoiData } = $poisStore);

	const searchParams = getSearchParamsStore();
	const { moveDrawer } = getMapLayoutContext();

	onMount(() => {
		// 272px is the height of the datasheet when the drawer is partially open
		setTimeout(() => moveDrawer(272), 0);
	});
</script>

<!-- TODO: Replace this if statement with a proper route guard in page.ts -->
{#if selectedPoiData && isDatasheetPoiData(selectedPoiData)}
	<DatasheetPanel
		poi={selectedPoiData}
		onClose={() => {
			gotoWithParams(ROUTE_ON_THE_WAY, { ...$searchParams, selectedPoi: undefined });
		}}
	/>
{/if}
<Footer {partnersLinks} />
